"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MapperBuilder_1 = require("./MapperBuilder");
class PropertyType extends MapperBuilder_1.default {
    constructor() {
        super();
        this.setStatus({
            APARTMENT: 'Residential / Apartment',
            HOME: 'Residential / Home',
            CONDO: 'Residential / Condo',
            INDUSTRIAL: 'Commercial / Industrial',
            BUILDING: 'Commercial / Building',
            KITNET: 'Residential / Kitnet',
            STUDIO: 'Residential / Studio',
            BUSINESS: 'Commercial / Business',
            OFFICE: 'Commercial / Office',
            SOBRADO: 'Residential / Sobrado',
        });
        this.setTranslations({
            [this.statusList.APARTMENT]: 'Apartamento',
            [this.statusList.HOME]: 'Casa',
            [this.statusList.CONDO]: 'Casa de Condomínio',
            [this.statusList.INDUSTRIAL]: 'Galpão/Depósito/Armazém',
            [this.statusList.BUILDING]: 'Imóvel Comercial',
            [this.statusList.KITNET]: 'Kitnet',
            [this.statusList.STUDIO]: 'Studio',
            [this.statusList.BUSINESS]: 'Loja/Salão/Box/Ponto Comercial',
            [this.statusList.OFFICE]: 'Conjunto Comercial/Sala',
            [this.statusList.SOBRADO]: 'Sobrado',
        });
        this.setAssertions({
            isApartment: this.buildAssertFunc(this.statusList.APARTMENT),
            isHome: this.buildAssertFunc(this.statusList.HOME),
            isCondo: this.buildAssertFunc(this.statusList.CONDO),
            isBuilding: this.buildAssertFunc(this.statusList.BUILDING),
            isIndustrial: this.buildAssertFunc(this.statusList.BUILDING),
            isKitnet: this.buildAssertFunc(this.statusList.KITNET),
            isStudio: this.buildAssertFunc(this.statusList.STUDIO),
            isBusiness: this.buildAssertFunc(this.statusList.BUSINESS),
            isOffice: this.buildAssertFunc(this.statusList.OFFICE),
            isSobrado: this.buildAssertFunc(this.statusList.SOBRADO),
        });
    }
}
exports.default = PropertyType;
//# sourceMappingURL=PropertyType.js.map